import React from 'react';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import css from './UMSLoadingDialog.scss';

export const UMS_LOADING_DIALOG = 'UMS_LOADING_DIALOG';

const UMSLoadingDialog = () => {
    return (
        <div className={css.loader}>
            <div className={css.cwLoading}>
                <div className={cx(css.cwLoadingSpinner, css.cwLoadingSpinnerChildOuter)}>
                    <div className={cx(css.cwLoadingSpinner, css.cwLoadingSpinnerChildInner)} />
                </div>
            </div>
        </div>
    );
};

export default injectIntl(UMSLoadingDialog);
